const PADRAO_VENDA = /^\s*venda\s+(\d+)\s*:\s*(.+)$/i;

const CATEGORIAS = [
    {
        chave: 'aguardando',
        titulo: 'Aguardando o Mercado Livre',
        acao: 'Resolve sozinho. Tente imprimir de novo em alguns minutos.',
        cor: 'orange',
        termos: [
            'processando a nota fiscal',
            'aguarda autorizacao da transportadora',
            'aguarda autorização da transportadora',
            'ainda nao liberou a etiqueta',
            'ainda não liberou a etiqueta',
        ],
    },
    {
        chave: 'instabilidade',
        titulo: 'Mercado Livre fora do ar',
        acao: 'Instabilidade momentânea. Tente de novo.',
        cor: 'yellow',
        termos: ['nao respondeu', 'não respondeu', 'sem_resposta'],
    },
    {
        chave: 'bloqueado',
        titulo: 'Precisa de conferência',
        acao: 'Não adianta reimprimir. Confira a situação do pedido antes de despachar.',
        cor: 'red',
        termos: [
            'cancelado',
            'entregue',
            'nao encontrou o envio',
            'não encontrou o envio',
            'nao entregue',
            'não entregue',
        ],
    },
    {
        chave: 'sem_danfe',
        titulo: 'Saiu sem a DANFE',
        acao: 'A etiqueta imprimiu normalmente. Só a DANFE ficou de fora, imprima ela à parte.',
        cor: 'blue',
        termos: ['a danfe falhou', 'juntar a danfe'],
    },
    {
        chave: 'sem_etiqueta',
        titulo: 'Sem etiqueta gerada',
        acao: 'Gere a etiqueta na aba Etiquetas antes de imprimir.',
        cor: 'purple',
        termos: ['sem etiqueta', 'nao retornou zpl', 'não retornou zpl', 'zpl nao encontrado', 'zpl não encontrado'],
    },
];

const CATEGORIA_PADRAO = {
    chave: 'outro',
    titulo: 'Outros problemas',
    acao: 'Confira a venda ou chame o suporte.',
    cor: 'gray',
};

const semAcento = (texto) => String(texto || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase();

export const classificarMotivo = (motivo) => {
    const alvo = semAcento(motivo);
    const achada = CATEGORIAS.find((c) => c.termos.some((t) => alvo.includes(semAcento(t))));
    return achada || CATEGORIA_PADRAO;
};

export const separarMensagem = (mensagem) => {
    const texto = String(mensagem || '').trim();
    if (!texto) return null;

    const casou = texto.match(PADRAO_VENDA);
    if (casou) {
        const motivo = casou[2].trim();
        return {
            vendaId: Number(casou[1]),
            motivo: motivo.charAt(0).toUpperCase() + motivo.slice(1),
        };
    }

    return { vendaId: null, motivo: texto };
};

export const agruparOcorrencias = (mensagens) => {
    const lista = Array.isArray(mensagens) ? mensagens : [];
    const grupos = new Map();

    lista.forEach((mensagem) => {
        const item = separarMensagem(mensagem);
        if (!item) return;

        const categoria = classificarMotivo(item.motivo);
        const chave = `${categoria.chave}::${semAcento(item.motivo)}`;

        if (!grupos.has(chave)) {
            grupos.set(chave, {
                chave,
                categoria: categoria.chave,
                titulo: categoria.titulo,
                acao: categoria.acao,
                cor: categoria.cor,
                motivo: item.motivo,
                vendas: [],
            });
        }

        if (item.vendaId !== null && !grupos.get(chave).vendas.includes(item.vendaId)) {
            grupos.get(chave).vendas.push(item.vendaId);
        }
    });

    const ordem = ['bloqueado', 'sem_etiqueta', 'aguardando', 'instabilidade', 'sem_danfe', 'outro'];

    return Array.from(grupos.values())
        .map((g) => ({ ...g, vendas: g.vendas.sort((a, b) => a - b) }))
        .sort((a, b) => {
            const posicao = ordem.indexOf(a.categoria) - ordem.indexOf(b.categoria);
            if (posicao !== 0) return posicao;
            return b.vendas.length - a.vendas.length;
        });
};

export const motivoPorVenda = (mensagens) => {
    const mapa = {};

    (Array.isArray(mensagens) ? mensagens : []).forEach((mensagem) => {
        const item = separarMensagem(mensagem);
        if (!item || item.vendaId === null) return;
        if (mapa[item.vendaId]) return;
        mapa[item.vendaId] = { motivo: item.motivo, ...classificarMotivo(item.motivo) };
    });

    return mapa;
};

export const resumoOcorrencias = (grupos) => {
    const vendas = new Set();
    let semVenda = 0;

    (grupos || []).forEach((g) => {
        if (g.vendas.length === 0) semVenda += 1;
        g.vendas.forEach((v) => vendas.add(v));
    });

    return { totalVendas: vendas.size, totalGrupos: (grupos || []).length, semVenda };
};

export const podeTentarDeNovo = (grupos) => (grupos || [])
    .some((g) => g.categoria === 'aguardando' || g.categoria === 'instabilidade');
